<template>
  <div id="gallery" class="gallery">
    <div
      class="image pull-left transition duration-500 ease-in-out transform hover:scale-105"
    >
      <router-link class="image-inner" :to="{ path: '/book' }" target="_blank">
        <img src="./img/one.png" alt="" />
      </router-link>

      <div class="image-info">
        <h5 class="title">PIHAK BERKUASA TEMPATAN (PBT)</h5>
      </div>
    </div>

    <div
      class="image pull-left transition duration-500 ease-in-out transform hover:scale-105"
      @click="navigateTo('/book')"
    >
      <router-link class="image-inner" :to="{ path: '/book' }" target="_blank">
        <img src="./img/two.png" alt="" />
      </router-link>
      <div class="image-info">
        <h5 class="title">PIHAK BERKUASA TEMPATAN (PBT)</h5>
      </div>
    </div>
    <div
      class="image pull-left transition duration-500 ease-in-out transform hover:scale-105"
      @click="navigateTo('/book')"
    >
      <router-link class="image-inner" :to="{ path: '/book' }" target="_blank">
        <img src="./img/three.png" alt="" />
      </router-link>
      <div class="image-info">
        <h5 class="title">PIHAK BERKUASA TEMPATAN (PBT)</h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
